import { useRef } from "react";
import { ChevronLeft, ChevronRight, Heart, Shirt } from "lucide-react";
import { UGCCard } from "@/components/UGCCard";
import { formatNum } from "@/lib/api";

const Row = ({ testid, items }) => {
  const ref = useRef(null);
  const scroll = (dir) => {
    const el = ref.current;
    if (!el) return;
    el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: "smooth" });
  };
  return (
    <div className="relative">
      <div className="absolute -top-11 right-0 flex gap-2 shrink-0">
        <button data-testid={`${testid}-prev`} onClick={() => scroll(-1)} aria-label="Previous"
          className="w-9 h-9 flex items-center justify-center border border-border hover:border-volt hover:text-volt transition-colors duration-200"><ChevronLeft className="w-4 h-4" /></button>
        <button data-testid={`${testid}-next`} onClick={() => scroll(1)} aria-label="Next"
          className="w-9 h-9 flex items-center justify-center border border-border hover:border-volt hover:text-volt transition-colors duration-200"><ChevronRight className="w-4 h-4" /></button>
      </div>
      <div ref={ref} data-lenis-prevent data-testid={testid} className="flex gap-5 overflow-x-auto pb-2 snap-x snap-mandatory">
        {items.map((it, i) => (
          <div key={it.asset_id} className="snap-start shrink-0 w-[170px] sm:w-[220px]">
            <UGCCard item={it} index={i} />
          </div>
        ))}
      </div>
    </div>
  );
};

export const GroupDrops = ({ group, items = [], clothing = [] }) => {
  return (
    <div data-testid={`group-drops-${group.id}`} className="mb-16">
      <div className="flex items-center gap-3 min-w-0 mb-6">
        {group.thumbnail_url && <img src={group.thumbnail_url} alt="" className="w-11 h-11 object-cover border border-border shrink-0" />}
        <div className="min-w-0">
          <h3 className="font-display font-bold text-xl uppercase tracking-tight leading-none truncate">{group.name}</h3>
          <div className="font-mono text-[10px] tracking-[0.15em] uppercase text-muted-foreground mt-2 flex items-center gap-1.5">
            <Heart className="w-3 h-3 text-volt" fill="currentColor" /> {formatNum(group.total_favorites)} favorites · {group.ugc_count} UGC
          </div>
        </div>
      </div>

      {items.length > 0 && (
        <div className="relative pt-11 mb-8">
          <span className="absolute top-0 left-0 font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">UGC Items</span>
          <Row testid={`carousel-${group.id}`} items={items} />
        </div>
      )}

      {clothing.length > 0 && (
        <div className="relative pt-11">
          <span className="absolute top-0 left-0 font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground flex items-center gap-1.5">
            <Shirt className="w-3.5 h-3.5 text-volt" /> Classic Clothing
          </span>
          <Row testid={`clothing-${group.id}`} items={clothing} />
        </div>
      )}
    </div>
  );
};
